export type Category = 'walls' | 'drawings' | 'sketches' | 'tattoos' | 'projects' | 'others';

export function parseCategory(c: string): Category | null {
  switch (c) {
    case 'drawings':
    case 'projects':
    case 'sketches':
    case 'tattoos':
    case 'walls':
    case 'others':
      return c;
    default:
      return null;
  }
}
